export default "__VITE_ASSET__El05wOmw__"